/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Settings_VisitorsInputs */

const en_admin_resource_form_settings_visitors = /** @type {(inputs: Admin_Resource_Form_Settings_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings (Visitors)`)
};

const de_admin_resource_form_settings_visitors = /** @type {(inputs: Admin_Resource_Form_Settings_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen (Besucher)`)
};

const es_admin_resource_form_settings_visitors = /** @type {(inputs: Admin_Resource_Form_Settings_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración (Visitantes)`)
};

const fr_admin_resource_form_settings_visitors = /** @type {(inputs: Admin_Resource_Form_Settings_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres (Visiteurs)`)
};

/** @type {(inputs: Admin_Resource_Form_Settings_VisitorsInputs) => LocalizedString} */
const it_admin_resource_form_settings_visitors = en_admin_resource_form_settings_visitors;

/** @type {(inputs: Admin_Resource_Form_Settings_VisitorsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_settings_visitors = en_admin_resource_form_settings_visitors;

/** @type {(inputs: Admin_Resource_Form_Settings_VisitorsInputs) => LocalizedString} */
const pl_admin_resource_form_settings_visitors = en_admin_resource_form_settings_visitors;

/** @type {(inputs: Admin_Resource_Form_Settings_VisitorsInputs) => LocalizedString} */
const hu_admin_resource_form_settings_visitors = en_admin_resource_form_settings_visitors;

/** @type {(inputs: Admin_Resource_Form_Settings_VisitorsInputs) => LocalizedString} */
const ro_admin_resource_form_settings_visitors = en_admin_resource_form_settings_visitors;

/**
* | output |
* | --- |
* | "Settings (Visitors)" |
*
* @param {Admin_Resource_Form_Settings_VisitorsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_settings_visitors = /** @type {((inputs?: Admin_Resource_Form_Settings_VisitorsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Settings_VisitorsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_settings_visitors(inputs)
	if (locale === "de") return de_admin_resource_form_settings_visitors(inputs)
	if (locale === "es") return es_admin_resource_form_settings_visitors(inputs)
	if (locale === "fr") return fr_admin_resource_form_settings_visitors(inputs)
	if (locale === "it") return it_admin_resource_form_settings_visitors(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_settings_visitors(inputs)
	if (locale === "pl") return pl_admin_resource_form_settings_visitors(inputs)
	if (locale === "hu") return hu_admin_resource_form_settings_visitors(inputs)
	return ro_admin_resource_form_settings_visitors(inputs)
});
export { admin_resource_form_settings_visitors as "admin.resource_form.settings_visitors" }